export default '/build/6227b31c.svg'